import { createFileRoute } from '@tanstack/react-router';
import { AuthProvider } from 'src/features/auth/contexts/AuthContext';
import NoMember from 'src/features/auth/components/NoMember';

export const Route = createFileRoute('/_auth/no-member')({
  head: () => ({
    meta: [{ title: 'No Member | Tekst' }],
  }),
  component: NoMemberPage,
});

function NoMemberPage() {
  function handleSupport() {
    window.location.href = 'https://support.tekst.com';
  }

  return (
    <AuthProvider>
      <NoMember redirectUrl="/login" className="w-[450px] h-[300px]" handleSupport={handleSupport} />
    </AuthProvider>
  );
}
